import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem.tsx';
import { DivInputStyle } from '../../../../../../ui/form/DivInputStyle.tsx';
import { ComputeExpressionPreview } from '../../../../../expressions/compute/preview/ComputeExpressionPreview.tsx';
import { type IWidgetParsedProps } from '../../../inputs/common/util/getWidgetProps.ts';
import {
  type IPaymentRowWidget,
  type PaymentRowWidgetFieldConfig,
} from '../IPaymentRowWidget.ts';

export interface IPaymentRowFieldPreviewProps {
  config: PaymentRowWidgetFieldConfig;
  options: IWidgetParsedProps;
  label: string;
  widget: IPaymentRowWidget;
}

export function PaymentRowFieldPreview(props: IPaymentRowFieldPreviewProps) {
  const { config, options, label, widget } = props;

  if (config.editable) {
    return (
      <ConfigFormItem
        name="string"
        label={label}
        readonly={options.readonly}
        widget={widget}
      >
        <TextInput name={options.name} />
      </ConfigFormItem>
    );
  }

  return (
    <ConfigFormItem
      name="string"
      label={label}
      readonly={options.readonly}
      widget={widget}
    >
      <DivInputStyle>
        <ComputeExpressionPreview expression={config.expression} />
      </DivInputStyle>
    </ConfigFormItem>
  );
}
